import { Component, ViewContainerRef } from '@angular/core';
import { config } from 'app/shared/smartadmin.config';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  public title = 'app works!';

  public constructor(private viewContainerRef: ViewContainerRef) {
    const favIcon: HTMLLinkElement = document.querySelector('#appIcon');
    favIcon.href = config.currentPark.logo;
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts